import { render } from "./RemoveDiscountCodeForm.vue?vue&type=template&id=1160d3d9&scoped=true"
import script from "./RemoveDiscountCodeForm.js?vue&type=script&lang=js"
export * from "./RemoveDiscountCodeForm.js?vue&type=script&lang=js"

import "./RemoveDiscountCodeForm.vue?vue&type=style&index=0&id=1160d3d9&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1160d3d9"]])

export default __exports__